export const BASE_URL = process.env.REACT_APP_BACKEND_URL ?? "https://sds3-henrique.herokuapp.com";